var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnableMinusBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#58B6A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52247 10.6236C9.47834 10.6251 9.43678 10.6266 9.39537 10.6271C8.5647 10.6278 7.73396 10.6282 6.90316 10.6282C6.81452 10.6305 6.72643 10.6138 6.64472 10.5794C6.56302 10.545 6.48959 10.4936 6.42926 10.4287C6.36893 10.3637 6.32308 10.2867 6.29477 10.2027C6.26646 10.1187 6.25632 10.0296 6.26504 9.94134C6.27879 9.78475 6.35112 9.63909 6.46758 9.53347C6.58405 9.42785 6.73606 9.37007 6.89324 9.37165C7.68616 9.37021 8.47845 9.36941 9.2701 9.36924C9.33487 9.36923 9.39957 9.36971 9.46509 9.37019C9.51326 9.37054 9.56187 9.3709 9.61128 9.37107L10.866 9.36594L10.8958 9.36694C10.912 9.36753 10.9261 9.36805 10.9402 9.36804L13.5696 9.36748C13.7251 9.36236 13.877 9.415 13.996 9.51525C14.115 9.6155 14.1926 9.75627 14.2139 9.91041C14.2265 9.99938 14.2198 10.09 14.1942 10.1762C14.1687 10.2623 14.1248 10.342 14.0656 10.4096C14.0065 10.4773 13.9335 10.5315 13.8515 10.5684C13.7696 10.6053 13.6806 10.624 13.5907 10.6234C13.1051 10.6264 12.6204 10.6261 12.1345 10.6257L11.8685 10.6255L10.8528 10.6278L9.61378 10.6207C9.58176 10.6215 9.55156 10.6226 9.52247 10.6236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableMinusBtn);
export default __webpack_public_path__ + "static/media/enable_minus_btn.7608c19a.svg";
export { ForwardRef as ReactComponent };